import { createElement, ReactNode, useState } from "react";
import { useLang } from "../services/lang";
import Dialog from "./Dialog";

export function ConfirmButton({ tag = "button", className, children, text, onClick }: { tag?: "button" | "a", className?: string, children: ReactNode, text: string, onClick: () => void }) {
    const { dict } = useLang();
    const [isOpen, setIsOpen] = useState(false);

    const button = createElement(tag, { className, onClick: () => setIsOpen(true) }, children);

    return <>
        {button}
        <Dialog show={isOpen} onClose={() => setIsOpen(false)}>
            <div className="confirm-dialog">
                <p>{text}</p>
                <div className="buttons">
                    <button onClick={() => {
                        onClick();
                        setIsOpen(false);
                    }}>{dict.yes}</button>
                    <button className="block" onClick={() => setIsOpen(false)}>{dict.cancel}</button>
                </div>
            </div>
        </Dialog>
    </>;
}
